// provide/inject 共享模块请求状态。getter 读取 Vue 响应式字段，避免复制状态失去同步。
// 一个模块内的图谱共用同一次请求；重试仍走该模块在 io/api.js 的接口入口。
export function createGraphRequestState(vm, loadMethod) {
    return {
        get loading() { return vm.loading; },
        get error() { return vm.loadError; },
        retry() {
            if (!vm.loading) return vm[loadMethod]();
        },
    };
}
